export default {"src":"/uk/_next/static/media/discoverIconGrey.422dddd0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};